module.exports = __webpack_public_path__ + "img/c01_buildingtechscalemail_Normal_ua.66b6dc77.webp";